export const BACKGROUND_EXPORT_QUEUE_KEY = '__background_export_queue__';

export interface BackgroundExportItem {
  _id: string;
  name: string;
  status: 'PENDING' | 'DONE' | 'ERROR';
  addedAt: string;
  userId: string;
}

const hasBrowserStorage = (): boolean => {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
};

export const getBackgroundExportQueue = (userId?: string): BackgroundExportItem[] => {
  if (!hasBrowserStorage()) {
    return [];
  }
  try {
    const value = window.localStorage.getItem(BACKGROUND_EXPORT_QUEUE_KEY);
    const allQueue = value ? JSON.parse(value) : [];
    // If userId is provided, filter by user, otherwise return all items
    return userId ? allQueue.filter((item: BackgroundExportItem) => item.userId === userId) : allQueue;
  } catch {
    return [];
  }
};

export const addToBackgroundExportQueue = (item: Omit<BackgroundExportItem, 'addedAt'>): void => {
  if (!hasBrowserStorage()) {
    return;
  }
  try {
    const queue = getBackgroundExportQueue();
    const exists = queue.some((queueItem) => queueItem._id === item._id && queueItem.userId === item.userId);
    if (!exists) {
      const newItem: BackgroundExportItem = {
        ...item,
        addedAt: new Date().toISOString(),
      };
      queue.push(newItem);
      window.localStorage.setItem(BACKGROUND_EXPORT_QUEUE_KEY, JSON.stringify(queue));
    }
  } catch {
  }
};

export const removeFromBackgroundExportQueue = (id: string): void => {
  if (!hasBrowserStorage()) {
    return;
  }
  try {
    const queue = getBackgroundExportQueue();
    const updatedQueue = queue.filter((item) => item._id !== id);
    window.localStorage.setItem(BACKGROUND_EXPORT_QUEUE_KEY, JSON.stringify(updatedQueue));
  } catch {
  }
};

export const updateBackgroundExportStatus = (id: string, status: 'PENDING' | 'DONE' | 'ERROR'): void => {
  if (!hasBrowserStorage()) {
    return;
  }
  try {
    const queue = getBackgroundExportQueue();
    const updatedQueue = queue.map((item) =>
      item._id === id ? { ...item, status } : item
    );
    window.localStorage.setItem(BACKGROUND_EXPORT_QUEUE_KEY, JSON.stringify(updatedQueue));
  } catch {
  }
};

export const clearBackgroundExportQueue = (): void => {
  if (!hasBrowserStorage()) {
    return;
  }
  try {
    window.localStorage.removeItem(BACKGROUND_EXPORT_QUEUE_KEY);
  } catch {
  }
};

export const getBackgroundExportQueueCount = (userId?: string): number => {
  return getBackgroundExportQueue(userId).filter((item) => item.status === 'PENDING').length;
};
